// extracted by mini-css-extract-plugin
export var dropdown = "_q2-1";
export var hidden = "_q2-0";